module.exports = __webpack_public_path__ + "img/downloadicon.1542e526.svg";